import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import deleteIntegration from './deleteIntegration';

export default (id) => (dispatch) => {
    const dataAlert = {
        confirmText: i18next.t('Delete'),
        messages: [
            i18next.t('Are you sure you want to delete this integration?'),
        ],
        onSuccess: () => dispatch(deleteIntegration(id)),
        title: i18next.t('Delete'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
